import { render, staticRenderFns } from "./StaffDropdown.vue?vue&type=template&id=5d666929"
import script from "./StaffDropdown.vue?vue&type=script&lang=js"
export * from "./StaffDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports